import { render, staticRenderFns } from "./Auction.vue?vue&type=template&id=b8dd5df6&"
import script from "./Auction.vue?vue&type=script&lang=js&"
export * from "./Auction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports